import { useKindeAuth } from '@kinde-oss/kinde-auth-react';

import { useEffect, useState } from 'react';
import { ConnectionStatusProvider } from '@vitvio/connection-provider';
import { I18nextProvider, i18n } from '@vitvio/locales';
import { API_URL, WEBSOCKET_URL, BUILD_ID, ENVIRONMENT, BRANCH } from '../config';
import { AuthenticatedApp } from './authenticated_app';
import { WholeScreenLoader, ErrorBoundary } from '@vitvio/shared-components';
import { BrowserDetection } from '@vitvio/browser-detection';
import { BuildMetadataProvider } from '@vitvio/build-metadata';
import mixpanel from 'mixpanel-browser';
import { ThemeProvider } from '@vitvio/design-system';

export function App() {
  const { login, isAuthenticated, getToken, isLoading, user } = useKindeAuth();

  const [token, setToken] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (isAuthenticated) {
      getToken &&
        getToken().then((token) => {
          setToken(token);
        });
    }
  }, [isAuthenticated, getToken]);

  useEffect(() => {
    if (user?.id) {
      mixpanel.identify(user?.id);
    }
  }, [user]);

  if (!isLoading && !isAuthenticated) {
    login();
    return null;
  }

  if (isLoading || !token) {
    return <WholeScreenLoader />;
  }

  return (
    <BuildMetadataProvider version={BUILD_ID} environment={ENVIRONMENT} branch={BRANCH}>
      <ThemeProvider>
        <ErrorBoundary userId={user?.id || ''}>
          <BrowserDetection>
            <ConnectionStatusProvider token={token} serverUrl={API_URL} webSocketUrl={WEBSOCKET_URL}>
              <I18nextProvider i18n={i18n} defaultNS="platform">
                <AuthenticatedApp />
              </I18nextProvider>
            </ConnectionStatusProvider>
          </BrowserDetection>
        </ErrorBoundary>
      </ThemeProvider>
    </BuildMetadataProvider>
  );
}

export default App;
